import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Lic. María Fernanda López',
  location: 'Rosario, Santa Fe',
  role: 'Psicóloga Clínica',
  quote: 'Siempre me sentí insegura al abordar el insomnio de mis pacientes, terminaba dando consejos básicos. Este kit me dio una estructura clara y herramientas concretas desde la primera sesión. El diario de sueño es excelente.'
}, {
  name: 'Lic. Tomás Giménez',
  location: 'Córdoba Capital',
  role: 'Psicoterapeuta TCC',
  quote: 'El material psicoeducativo que incluye es de primer nivel. Me ahorró horas de armar mis propios recursos. Mis pacientes con ansiedad valoran muchísimo tener guías tan claras para llevarse a casa.'
}, {
  name: 'Lic. Carolina Sánchez',
  location: 'CABA, Buenos Aires',
  role: 'Psicóloga',
  quote: 'Un recurso indispensable. La forma en que estructura las 6 etapas te ordena el tratamiento por completo. Lo apliqué con un paciente con burnout severo y los resultados en su descanso fueron notables a las pocas semanas.'
}, {
  name: 'Lic. Javier Ruiz',
  location: 'Mendoza',
  role: 'Psicólogo Clínico',
  quote: 'Excelente inversión. No es teoría aburrida, es pura práctica clínica. Las plantillas y el protocolo de intervención cognitiva me ayudaron a destrabar casos donde la rumiación nocturna era el principal obstáculo.'
}, {
  name: 'Lic. Agustina Herrera',
  location: 'La Plata, Buenos Aires',
  role: 'Terapeuta',
  quote: 'Me encantó la claridad del material. Saber exactamente qué evaluar y cómo diferenciar si el insomnio es primario o secundario me dio mucha más seguridad en mis diagnósticos. Los bonus son un regalo espectacular.'
}];
export function Testimonials() {
  return <section className="py-20 bg-[#fdfbf6]" data-id="element-212">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="text-center mb-12" data-id="element-214">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-215">
            Lo que dicen otros profesionales
          </h2>
          <p className="text-slate-600" data-id="element-216">
            Psicólogos y terapeutas que ya integraron el sistema a su práctica
            clínica.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-217">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white p-8 rounded-2xl shadow-sm border border-slate-100 ${index === 3 || index === 4 ? 'lg:col-span-1.5' : ''}`} data-id="element-218">
              <div className="flex gap-1 mb-4" data-id="element-219">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-220" />)}
              </div>
              <p className="text-slate-700 italic mb-6 leading-relaxed" data-id="element-221">
                "{testimonial.quote}"
              </p>
              <div data-id="element-222">
                <p className="font-bold text-navy" data-id="element-223">{testimonial.name}</p>
                <p className="text-sm text-slate-500" data-id="element-224">
                  {testimonial.role} · {testimonial.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}